var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_38_3688)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99999 0.399902C4.69699 0.399902 0.398987 4.6979 0.398987 9.9999C0.398856 11.2608 0.647103 12.5093 1.12955 13.6742C1.612 14.8391 2.3192 15.8976 3.21076 16.7891C4.10232 17.6807 5.16078 18.3879 6.32569 18.8703C7.49059 19.3528 8.73913 19.601 9.99999 19.6009C15.301 19.6009 19.6 15.3029 19.6 9.9999C19.6 4.6979 15.301 0.399902 9.99999 0.399902ZM10.896 3.8659C11.832 3.8659 12.107 4.4089 12.107 5.0299C12.107 5.8049 11.487 6.5219 10.428 6.5219C9.54199 6.5219 9.11999 6.0769 9.14599 5.3399C9.14599 4.7189 9.66499 3.8659 10.896 3.8659ZM8.49799 15.7499C7.85799 15.7499 7.39099 15.3609 7.83799 13.6559L8.57099 10.6309C8.69799 10.1469 8.71899 9.9529 8.57099 9.9529C8.37999 9.9529 7.54899 10.2869 7.05899 10.6169L6.73999 10.0939C8.29499 8.7949 10.083 8.0329 10.848 8.0329C11.488 8.0329 11.594 8.7889 11.275 9.9529L10.435 13.1329C10.286 13.6949 10.35 13.8889 10.499 13.8889C10.691 13.8889 11.319 13.6569 11.937 13.1699L12.299 13.6559C10.786 15.1679 9.13699 15.7499 8.49799 15.7499Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_38_3688"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.c0fdfc1e93ec0518bbc05424450fd90f.svg";
export { ForwardRef as ReactComponent };